import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import styled from 'styled-components'

import NoProductImage from '../assets/no-product-image.png'
import { push } from 'connected-react-router'
import { useDispatch } from 'react-redux'
import { useMemo } from 'react'

const ProductCard = props => {
    const dispatch = useDispatch()

    const image = props.images.length > 0 ? props.images[0].path : NoProductImage

    // 割引後価格
    const discountedPrice = useMemo(()=>{
        return Math.round( props.price * (1 - props.discount / 100) )
    }, [props.price, props.discount])

    return (
        <>
        { (!props.isTrash && !props.isDraft) && (
            <ProductCardWrapper>
                <CardActionArea onClick={()=>dispatch(push('/product/dp/' + props.id))}>
                    <ImageWrapper>
                        <CardMediaWrapper src={image} alt={'product image'}/>
                    </ImageWrapper>
                    <CardContentWrapper>
                        <FlexBox>
                            <PriceWrapper>
                                <PriceTag>
                                    <span style={{fontSize:'1rem',marginRight:'5px'}}>&yen;</span>
                                    {discountedPrice.toLocaleString()}
                                </PriceTag>
                                {props.discount > 0 && <DiscountTag>{props.discount + '%OFF'}</DiscountTag> }
                            </PriceWrapper>
                            <p>{props.name}</p>
                        </FlexBox>
                    </CardContentWrapper>
                </CardActionArea>
            </ProductCardWrapper>
        )}
        </>
    )
}
export default ProductCard

const ProductCardWrapper = styled.div`
    width: 240px;
    height: 360px;
    padding: 10px;
    background-color: transparent;
    box-shadow: none;
`
const ImageWrapper = styled.div`
    background-color: #7ABECE;
    display:inline-block;
    position: relative;
    cursor: pointer;
`
const CardMediaWrapper = styled.img`
    object-fit: contain;
    width: 220px;
    height: 220px;
    background-color: #fff;
    opacity: 1;
    &:hover {
        transition: 1s all;
        opacity: 0.5;
        display:block;
    }
`
const CardContentWrapper = styled(CardContent)`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    height: 120px;
    background-color: #000;
`
const FlexBox = styled.div`
    height: 120px;
    display: flex;
    flex-direction: column;
`
const PriceWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
`
const PriceTag = styled.span`
    font-size: 1.5rem;
    margin-right: 10px;
`
const DiscountTag = styled.span`
    width: 80px;
    font-size: .8rem;
    padding: 5px 10px;
    color: #333;
    background-color: #FCEB04;
    border-radius: 4px;
    text-align: center;
`